import PropTypes from 'prop-types';
import { Component, createRef } from 'react';
import classNames from 'classnames';
import { Map as ImmutableMap } from 'immutable';
import StateConstants from '../../../constants/StateConstants';
import { tinymceLocalStorage } from '../../../utils/localStorage';
import TinyMceBodyEditor from './BodyEditor';
import SubtitleEditor from './SubtitleEditor';
import TitleEditor from './TitleEditor';
import NewInsertMenuPopover from './NewInsertMenuPopover';
import ArticleFontWrapper from './ArticleFontWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class EditorTinyMCE extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorActive: false,
      editorHasBeenActive: false,
      userHasSeenNewInsertMenuPopover: tinymceLocalStorage.insertPopoverSeen()
    };
    this.onEditorBlur = () => {
      this.clearBlurTimeout();
      this.editorBlurTimeout = setTimeout(() => {
        this.setState({
          editorActive: false
        });
      }, 200);
    };
    this.onEditorFocus = () => {
      this.setState({
        editorActive: true,
        editorHasBeenActive: true
      });
    };
    this.onNewInsertPopoverDismiss = () => {
      tinymceLocalStorage.setInsertPopoverDismiss();
      this.setState({
        userHasSeenNewInsertMenuPopover: true
      });
    };
    this.toolbarContainerRef = /*#__PURE__*/createRef();
  }
  componentWillUnmount() {
    this.clearBlurTimeout();
  }
  clearBlurTimeout() {
    if (this.editorBlurTimeout) {
      clearTimeout(this.editorBlurTimeout);
      this.editorBlurTimeout = null;
    }
  }
  render() {
    const {
      articleSubtitle,
      articleTitle,
      article,
      canWriteArticle,
      className,
      linksColor,
      onArticleSubtitleChange,
      onArticleTitleBlur,
      onArticleTitleChange,
      readOnly,
      templateSettings,
      titleInputRef
    } = this.props;
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(ArticleFontWrapper, {
        "data-test-id": "editor",
        className: 'knowledge-editor' + (article.values.hs_state === StateConstants.PUBLISHED && !canWriteArticle || readOnly ? " text-disabled" : "")
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        ,
        linksColor: linksColor,
        templateSettings: templateSettings,
        children: [/*#__PURE__*/_jsx(NewInsertMenuPopover, {
          onDismiss: this.onNewInsertPopoverDismiss,
          open: this.state.editorActive && !this.state.userHasSeenNewInsertMenuPopover,
          toolbarRef: this.toolbarContainerRef
        }), /*#__PURE__*/_jsx("div", {
          id: "tinymce-toolbar",
          ref: this.toolbarContainerRef,
          className: this.state.editorActive ? 'active' : 'inactive'
        }), /*#__PURE__*/_jsxs("div", {
          className: classNames('knowledge-editor-scroll-container', className),
          translate: "no",
          children: [/*#__PURE__*/_jsx(TitleEditor
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          , {
            autoFocus: canWriteArticle,
            className: 'article-title' + (article.values.hs_state === StateConstants.PUBLISHED && !canWriteArticle || readOnly ? " text-disabled" : ""),
            disabled: !canWriteArticle || readOnly,
            inputRef: titleInputRef,
            onBlur: onArticleTitleBlur,
            onChange: onArticleTitleChange,
            value: articleTitle,
            "data-test-id": "article-title",
            tabIndex: "1"
          }), /*#__PURE__*/_jsx(SubtitleEditor
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          , {
            className: "article-summary",
            "data-test-id": "article-summary",
            disabled: !canWriteArticle || readOnly,
            onChange: onArticleSubtitleChange,
            tabIndex: "2",
            value: articleSubtitle
          }), /*#__PURE__*/_jsx(TinyMceBodyEditor, {
            className: "article-body",
            readOnly: !canWriteArticle || readOnly,
            onFocus: this.onEditorFocus,
            onBlur: this.onEditorBlur
          })]
        })]
      })
    });
  }
}
EditorTinyMCE.propTypes = {
  articleSubtitle: PropTypes.string,
  articleTitle: PropTypes.string,
  canWriteArticle: PropTypes.bool.isRequired,
  className: PropTypes.string,
  linksColor: PropTypes.string.isRequired,
  onArticleSubtitleChange: PropTypes.func.isRequired,
  onArticleTitleBlur: PropTypes.func.isRequired,
  onArticleTitleChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Map' is not assignable to... Remove this comment to see the full error message
  templateSettings: PropTypes.instanceOf(ImmutableMap).isRequired,
  titleInputRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })
};
export default EditorTinyMCE;